"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeOwnershipType = exports.HomeCoverLevelEnum = exports.OptionalExtras = exports.MotorAddons = exports.HomeAddons = exports.MotorCoverTier = exports.HomeCoverTier = exports.CourtesyCarLevelEnum = exports.BreakdownCoverLevelEnum = exports.AnnualPolicyPremiumTypeEnum = exports.PolicyPropertyEnum = exports.PartyPropertyEnum = exports.ProductNameEnum = exports.SessionStorageItemEnum = exports.ValuableItemCoverLocation = exports.AnnualHomeAutomaticInsuredItemTypes = exports.ValuableItemTypeEnum = exports.ProductIdEnum = exports.ProductsEnum = exports.IncludedProductsEnum = void 0;
var IncludedProductsEnum;
(function (IncludedProductsEnum) {
    IncludedProductsEnum[IncludedProductsEnum["MOTOR"] = 1] = "MOTOR";
    IncludedProductsEnum[IncludedProductsEnum["RENTERS"] = 2] = "RENTERS";
    IncludedProductsEnum[IncludedProductsEnum["WOLF_MOTOR"] = 4] = "WOLF_MOTOR";
    // Next products should be added with following values: 8,16,32,64...
})(IncludedProductsEnum || (exports.IncludedProductsEnum = IncludedProductsEnum = {}));
var ProductsEnum;
(function (ProductsEnum) {
    ProductsEnum["MOTOR"] = "PropositionFalconMotorInsurance";
    ProductsEnum["WOLF_MOTOR"] = "PropositionWolfMotorInsurance";
    ProductsEnum["RENTERS"] = "PropositionFalconRentersInsurance";
    ProductsEnum["SUBSCRIPTION"] = "FlowSubscription";
    ProductsEnum["HOME"] = "AnnualHomeInsurance";
})(ProductsEnum || (exports.ProductsEnum = ProductsEnum = {}));
var ProductIdEnum;
(function (ProductIdEnum) {
    ProductIdEnum[ProductIdEnum["MOTOR"] = 1] = "MOTOR";
    ProductIdEnum[ProductIdEnum["WOLF_MOTOR"] = 3] = "WOLF_MOTOR";
    ProductIdEnum[ProductIdEnum["HOME"] = 4] = "HOME";
})(ProductIdEnum || (exports.ProductIdEnum = ProductIdEnum = {}));
var ValuableItemTypeEnum;
(function (ValuableItemTypeEnum) {
    ValuableItemTypeEnum["MOBILE"] = "MOBILE";
    ValuableItemTypeEnum["BIKE"] = "BIKE";
    ValuableItemTypeEnum["LAPTOP"] = "LAPTOP";
    ValuableItemTypeEnum["COMPUTER"] = "COMPUTER";
    ValuableItemTypeEnum["TABLET"] = "TABLET";
    ValuableItemTypeEnum["TV"] = "TV";
    ValuableItemTypeEnum["CAMERA"] = "CAMERA";
    ValuableItemTypeEnum["JEWELLERY"] = "JEWELLERY";
    ValuableItemTypeEnum["SPORT"] = "SPORT";
    ValuableItemTypeEnum["HEARING"] = "HEARING";
    ValuableItemTypeEnum["WHEELCHAIR"] = "WHEELCHAIR";
    ValuableItemTypeEnum["MUSIC"] = "MUSIC";
    ValuableItemTypeEnum["HEADPHONES"] = "HEADPHONES";
})(ValuableItemTypeEnum || (exports.ValuableItemTypeEnum = ValuableItemTypeEnum = {}));
var AnnualHomeAutomaticInsuredItemTypes;
(function (AnnualHomeAutomaticInsuredItemTypes) {
    AnnualHomeAutomaticInsuredItemTypes["CLOTHING"] = "CLOTHING";
    AnnualHomeAutomaticInsuredItemTypes["COMPUTER"] = "COMPUTER_FLOW_HOME";
    AnnualHomeAutomaticInsuredItemTypes["GADGET"] = "GADGET";
    AnnualHomeAutomaticInsuredItemTypes["GUN"] = "GUN";
    AnnualHomeAutomaticInsuredItemTypes["HEARING"] = "HEARING";
    AnnualHomeAutomaticInsuredItemTypes["MOBILE"] = "MOBILE";
    AnnualHomeAutomaticInsuredItemTypes["MUSIC"] = "MUSIC";
    AnnualHomeAutomaticInsuredItemTypes["PHOTOGRAPHIC_EQUIPMENT"] = "PHOTOGRAPHIC_EQUIPMENT";
    AnnualHomeAutomaticInsuredItemTypes["COLLECTION"] = "COLLECTION";
    AnnualHomeAutomaticInsuredItemTypes["SPORT"] = "SPORT";
    AnnualHomeAutomaticInsuredItemTypes["WHEELCHAIR"] = "WHEELCHAIR_FLOW_HOME";
})(AnnualHomeAutomaticInsuredItemTypes || (exports.AnnualHomeAutomaticInsuredItemTypes = AnnualHomeAutomaticInsuredItemTypes = {}));
var ValuableItemCoverLocation;
(function (ValuableItemCoverLocation) {
    ValuableItemCoverLocation["HOME"] = "HOME";
    ValuableItemCoverLocation["ANYWHERE"] = "ANYWHERE";
})(ValuableItemCoverLocation || (exports.ValuableItemCoverLocation = ValuableItemCoverLocation = {}));
var SessionStorageItemEnum;
(function (SessionStorageItemEnum) {
    SessionStorageItemEnum["ADDRESS_CHANGED"] = "FalconAddressChanged";
    SessionStorageItemEnum["ADDRESS_CHANGE_REFERER"] = "FalconAddressChangeReferer";
    SessionStorageItemEnum["SESSION_STORAGE_ALLIANZ_PROMOTION_SHOWN"] = "allianzPromotionShown";
    SessionStorageItemEnum["SESSION_STORAGE_EVENT_WARNING_PAGE_SHOWN"] = "eventWarningPageShown";
})(SessionStorageItemEnum || (exports.SessionStorageItemEnum = SessionStorageItemEnum = {}));
var ProductNameEnum;
(function (ProductNameEnum) {
    ProductNameEnum["MOTOR"] = "MOTOR";
    ProductNameEnum["RENTERS"] = "RENTERS";
    ProductNameEnum["WOLF_MOTOR"] = "ANNUAL_MOTOR";
    ProductNameEnum["ANNUAL_HOME"] = "ANNUAL_HOME";
})(ProductNameEnum || (exports.ProductNameEnum = ProductNameEnum = {}));
var PartyPropertyEnum;
(function (PartyPropertyEnum) {
    PartyPropertyEnum["CARS_IN_HOUSEHOLD"] = "carsInHousehold";
    PartyPropertyEnum["SEND_DOCUMENTS_BY_EMAIL"] = "sendDocumentsByEmail";
    PartyPropertyEnum["SEND_DOCUMENTS_BY_POST"] = "sendDocumentsByPost";
    PartyPropertyEnum["MARKETING_PREFERENCES_EMAIL"] = "marketingPreferencesEmail";
    PartyPropertyEnum["MARKETING_PREFERENCES_PHONE"] = "marketingPreferencesPhone";
    PartyPropertyEnum["MARKETING_PREFERENCES_POST"] = "marketingPreferencesPost";
    PartyPropertyEnum["MARKETING_PREFERENCES_SMS"] = "marketingPreferencesSMS";
    PartyPropertyEnum["MOVED_TO_ADDRESS"] = "movedToAddress";
    PartyPropertyEnum["OWNS_HOME"] = "ownsHome";
    PartyPropertyEnum["CUSTOMER_LV_MEMBER"] = "customerLVMember";
    PartyPropertyEnum["HAS_UNSPENT_CRIMINAL_CONVICTIONS"] = "hasUnspentCriminalConvictions";
    PartyPropertyEnum["BUSINESS_USE"] = "businessUse";
    PartyPropertyEnum["LAST_VRN_CHANGE_DATE_TEMPLATE"] = "lastVehicleRegistrationNumberChangeDateForPolicy%d";
    PartyPropertyEnum["BILLING_ADDRESS_CHANGE_ALLOWED"] = "billingAddressChangeAllowed";
    PartyPropertyEnum["VULNERABLE_CUSTOMER"] = "vulnerableCustomer";
    PartyPropertyEnum["ACTIVE_VULNERABLE_CUSTOMER_ACTION"] = "activeVulnerableCustomerAction";
    PartyPropertyEnum["ALLIANZ_PROMOTION_SHOWN"] = "allianzPromotionShown";
    PartyPropertyEnum["ALLIANZ_ONLINE_SHOWN"] = "allianzOnlineShown";
})(PartyPropertyEnum || (exports.PartyPropertyEnum = PartyPropertyEnum = {}));
var PolicyPropertyEnum;
(function (PolicyPropertyEnum) {
    PolicyPropertyEnum["REUSE_MAIN_CARD"] = "reuseMainCard";
    PolicyPropertyEnum["POLICY_DEBT"] = "policyDebt";
    PolicyPropertyEnum["AUTOMATIC_RENEWAL"] = "automaticRenewal";
    PolicyPropertyEnum["PERFORM_RENEWAL"] = "performRenewal";
    PolicyPropertyEnum["SUPPRESS_RENEWAL"] = "suppressRenewal";
    PolicyPropertyEnum["MAIN_ANNUAL_PAYMENT_CARD"] = "mainAnnualPaymentCard";
    PolicyPropertyEnum["ANNUAL_MONTHLY_OPTION_CARD_EXPIRED"] = "annualMonthlyOptionCardExpired";
    PolicyPropertyEnum["DIRECT_DEBIT_SUPPORTED"] = "directDebitSupported";
})(PolicyPropertyEnum || (exports.PolicyPropertyEnum = PolicyPropertyEnum = {}));
var AnnualPolicyPremiumTypeEnum;
(function (AnnualPolicyPremiumTypeEnum) {
    AnnualPolicyPremiumTypeEnum["ANNUAL"] = "annual";
    AnnualPolicyPremiumTypeEnum["MONTHLY"] = "monthly";
})(AnnualPolicyPremiumTypeEnum || (exports.AnnualPolicyPremiumTypeEnum = AnnualPolicyPremiumTypeEnum = {}));
var BreakdownCoverLevelEnum;
(function (BreakdownCoverLevelEnum) {
    BreakdownCoverLevelEnum["LOCAL"] = "LOCAL";
    BreakdownCoverLevelEnum["UK"] = "UK";
    BreakdownCoverLevelEnum["EU"] = "EU";
})(BreakdownCoverLevelEnum || (exports.BreakdownCoverLevelEnum = BreakdownCoverLevelEnum = {}));
var CourtesyCarLevelEnum;
(function (CourtesyCarLevelEnum) {
    CourtesyCarLevelEnum["BASIC"] = "BASIC";
    CourtesyCarLevelEnum["ENHANCED"] = "ENHANCED";
    CourtesyCarLevelEnum["NONE"] = "NONE";
})(CourtesyCarLevelEnum || (exports.CourtesyCarLevelEnum = CourtesyCarLevelEnum = {}));
var HomeCoverTier;
(function (HomeCoverTier) {
    HomeCoverTier["BRONZE"] = "BRONZE";
    HomeCoverTier["SILVER"] = "SILVER";
    HomeCoverTier["GOLD"] = "GOLD";
})(HomeCoverTier || (exports.HomeCoverTier = HomeCoverTier = {}));
var MotorCoverTier;
(function (MotorCoverTier) {
    MotorCoverTier["ALLIANZ_ESSENTIALS"] = "ALLIANZ_ESSENTIALS";
    MotorCoverTier["ALLIANZ_SILVER"] = "ALLIANZ_SILVER";
    MotorCoverTier["ALLIANZ"] = "ALLIANZ";
})(MotorCoverTier || (exports.MotorCoverTier = MotorCoverTier = {}));
var HomeAddons;
(function (HomeAddons) {
    HomeAddons["HOME_LEGAL_EXPENSES"] = "Home Legal Expenses";
    HomeAddons["HOME_EMERGENCY"] = "Home Emergency";
})(HomeAddons || (exports.HomeAddons = HomeAddons = {}));
var MotorAddons;
(function (MotorAddons) {
    MotorAddons["PROTECTED_NCD"] = "Protected No Claim Discount";
    MotorAddons["LEGAL_EXPENSES"] = "Motor Legal Expenses";
    MotorAddons["COURTESY_CAR"] = "Courtesy Car";
    MotorAddons["COURTESY_CAR_TOTAL_LOSS"] = "Courtesy Car Total Loss";
    MotorAddons["BREAKDOWN_COVER_LOCAL"] = "Breakdown Cover - Local level";
    MotorAddons["BREAKDOWN_COVER_UK"] = "Breakdown Cover - UK level";
    MotorAddons["BREAKDOWN_COVER_EU"] = "Breakdown Cover - EU level";
})(MotorAddons || (exports.MotorAddons = MotorAddons = {}));
var OptionalExtras;
(function (OptionalExtras) {
    OptionalExtras["BREAKDOWN_COVER_LOCAL"] = "BREAKDOWN_COVER_LOCAL";
    OptionalExtras["BREAKDOWN_COVER_UK"] = "BREAKDOWN_COVER_UK";
    OptionalExtras["BREAKDOWN_COVER_EU"] = "BREAKDOWN_COVER_EU";
    OptionalExtras["LEGAL_EXPENSES"] = "LEGAL_EXPENSES";
    OptionalExtras["HOME_LEGAL_EXPENSES"] = "HOME_LEGAL_EXPENSES";
    OptionalExtras["HOME_EMERGENCY"] = "HOME_EMERGENCY";
})(OptionalExtras || (exports.OptionalExtras = OptionalExtras = {}));
var HomeCoverLevelEnum;
(function (HomeCoverLevelEnum) {
    HomeCoverLevelEnum["BUILDINGS_CONTENTS"] = "BUILDINGS_CONTENTS";
    HomeCoverLevelEnum["BUILDINGS"] = "BUILDINGS";
    HomeCoverLevelEnum["CONTENTS"] = "CONTENTS";
})(HomeCoverLevelEnum || (exports.HomeCoverLevelEnum = HomeCoverLevelEnum = {}));
var HomeOwnershipType;
(function (HomeOwnershipType) {
    HomeOwnershipType["OWNED_OUTRIGHT"] = "OWNED_OUTRIGHT";
    HomeOwnershipType["OWNED_MORTGAGED"] = "OWNED_MORTGAGED";
    HomeOwnershipType["RENTED"] = "RENTED";
    HomeOwnershipType["RENTED_PRIVATE_UNFURNISHED"] = "RENTED_PRIVATE_UNFURNISHED";
    HomeOwnershipType["RENTED_PRIVATE_FURNISHED"] = "RENTED_PRIVATE_FURNISHED";
    HomeOwnershipType["HOUSING_ASSOCIATION"] = "HOUSING_ASSOCIATION";
    HomeOwnershipType["RENTED_COUNCIL"] = "RENTED_COUNCIL";
    HomeOwnershipType["LANDLORD"] = "LANDLORD";
})(HomeOwnershipType || (exports.HomeOwnershipType = HomeOwnershipType = {}));
//# sourceMappingURL=enums.js.map